import { Observable } from 'rxjs';
import { HttpContext } from '@angular/common/http';
import { IGNORAR_ERRO_GLOBAL } from '@core/services/api/interceptor';
import { NotificationCenterResponse, NotificationConfig, NotificationTab } from '@model/notification-center.model';
import { Injectable, inject } from '@angular/core';
import { BaseCrud } from '@core/services/api/routes/helpers/baseCrud';
import { LengthAwarePaginator } from '@model/common/length-aware-paginator.model';
import { NotificationModel } from '@model/notification.model';
import { RouteQueryParams, toHttpParams } from '@core/services/api/interfaces/query-params';
import { ApiEndpointService } from '../../api-endpoint.service';

/** Notificações legadas do app e contrato aditivo da central da top bar. */
@Injectable({
  providedIn: 'root',
})
export class NotificationRoute extends BaseCrud {
  constructor() {
    super(inject(ApiEndpointService));
  }

  getUrl(): string {
    return `${this.api.getApiUrl()}/notifications`;
  }

  /**
   * `read: false` filtra só as não lidas (`NotificationService::list`,
   * `financeiro-api`) — contrato legado do aplicativo.
   */
  list(params?: RouteQueryParams): Observable<LengthAwarePaginator<NotificationModel[]>> {
    return this.api.getHttp().get<LengthAwarePaginator<NotificationModel[]>>(this.getUrl(), {
      params: toHttpParams(params),
    });
  }

  markAsRead(id: string): Observable<NotificationModel> {
    return this.api.getHttp().post<NotificationModel>(`${this.getUrl()}/${id}`, {});
  }

  markAllAsRead(): Observable<void> {
    return this.api.getHttp().post<void>(`${this.getUrl()}/mark-all`, {});
  }

  center(tab: NotificationTab = 'pending', page = 1, perPage = 20): Observable<NotificationCenterResponse> {
    return this.api.getHttp().get<NotificationCenterResponse>(`${this.getUrl()}/center`, {
      params: toHttpParams({ tab, page, per_page: perPage }),
      context: new HttpContext().set(IGNORAR_ERRO_GLOBAL, true),
    });
  }

  readCenter(id: string): Observable<void> {
    return this.api.getHttp().post<void>(`${this.getUrl()}/center/${encodeURIComponent(id)}/read`, {});
  }

  readAllCenter(): Observable<void> {
    return this.api.getHttp().post<void>(`${this.getUrl()}/center/mark-all`, {});
  }

  notificationConfig(): Observable<NotificationConfig[]> {
    return this.api.getHttp().get<NotificationConfig[]>(`${this.getUrl()}/list-config`);
  }

  updateNotificationConfig(action: string, value: boolean | number): Observable<void> {
    return this.api.getHttp().post<void>(`${this.getUrl()}/update-config`, { action, value });
  }

}
